<template>
  <input :class="classes" :value="inner" type="date" @input="doInput" />
</template>

<script>
import moment from 'moment'
export default {
  props: ['value', 'css'],
  computed: {
    classes() {
      const classes = ['form-control']
      if (this.css) {
        classes.push(this.css)
      }
      return classes.join(' ')
    },
    inner() {
      if (this.value) {
        const date = moment(this.value)
        return date.local().format('YYYY-MM-DD')
      } else {
        return null
      }
    },
  },
  methods: {
    doInput(evt) {
      const value = evt.target.value
      if (value) {
        const time = new Date(value).toISOString()
        this.$emit('input', time)
      } else {
        this.$emit('input', null)
      }
    },
  },
}
</script>
